import {
  Dialog,
  DialogVariant,
  textStyleUtils
} from '@focaldata/cin-ui-components'
import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useState
} from 'react'

interface PendingMove {
  message: string
  move: () => void
}

const LoopedSectionMoveConfirmContext = createContext<
  ((pending: PendingMove) => void) | null
>(null)

/** Asks before a move into a looped section drops KPIs; null outside the questionnaire editor. */
export const useConfirmLoopedSectionMove = () =>
  useContext(LoopedSectionMoveConfirmContext)

export const LoopedSectionMoveConfirmProvider = ({
  children
}: {
  children: ReactNode
}) => {
  const [pending, setPending] = useState<PendingMove | null>(null)
  const [isOpen, setIsOpen] = useState(false)
  const { classes: textClasses, cx: classNames } =
    textStyleUtils.useTextStyles()

  const confirm = useCallback((next: PendingMove) => {
    setPending(next)
    setIsOpen(true)
  }, [])
  const close = () => setIsOpen(false)

  return (
    <LoopedSectionMoveConfirmContext.Provider value={confirm}>
      {children}
      <Dialog
        title="Move into a looped section?"
        open={isOpen}
        onClose={close}
        variant={DialogVariant.DoubleButton}
        primaryButtonText="Move question"
        primaryButtonClick={() => {
          close()
          pending?.move()
        }}
        secondaryButtonText="Cancel"
        secondaryButtonClick={close}
      >
        <p
          className={classNames(
            textClasses.default,
            textClasses.weightSemiBold
          )}
        >
          {pending?.message}
        </p>
      </Dialog>
    </LoopedSectionMoveConfirmContext.Provider>
  )
}
